import App from '../app';

import ScrollController from './scroll';

class ResizeController {

	#subscribers = [];

	#setViewport() {
		const vw = document.body.clientWidth;
		const vh = window.innerHeight;
		document.documentElement.style.setProperty('--grid-width', `${vw}px`);
		document.documentElement.style.setProperty('--grid-height', `${vh}px`);
	}

	initialize() {
		this.#setViewport();
		this.#addEventListeners();
	}

	resize() {
		this.#setViewport();
		for (const subscriber of this.#subscribers) {
			if (subscriber) subscriber();
		}
		ScrollController.resize();
		if (!App.isTouch) ScrollController.holdPosition();
	}

	add(fn) {
		this.#subscribers.push(fn);
	}

	remove(fn) {
		for (let i = 0, l = this.#subscribers.length; i < l; ++i) {
			if (fn === this.#subscribers[i]) {
				delete this.#subscribers[i];
				break;
			}
		}
	}

	#onWindowResize = () => {
		this.resize();
	}

	#addEventListeners() {
		window.addEventListener('resize', this.#onWindowResize);
	}

	#removeEventListeners() {
		window.removeEventListener('resize', this.#onWindowResize);
	}

}

export default new ResizeController();
